module.exports = __webpack_public_path__ + "e31c7d81d98c09ef2946de387ca4cfd5.svg";